// extracted by mini-css-extract-plugin
export var articleWrapper = "Grid-module--article-wrapper--986ea";
export var linkWrapper = "Grid-module--link-wrapper--e1bb2";
export var posterWrapper = "Grid-module--poster-wrapper--2d679";
export var root = "Grid-module--root--c5c87";